import script from "./taskNotesChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./taskNotesChat.vue?vue&type=script&setup=true&lang=ts"

import "./taskNotesChat.vue?vue&type=style&index=0&id=78d4060b&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d4060b"]])

export default __exports__